import { render, staticRenderFns } from "./LoadingMedicalIdentity.vue?vue&type=template&id=048d96f1&scoped=true"
import script from "./LoadingMedicalIdentity.vue?vue&type=script&lang=js"
export * from "./LoadingMedicalIdentity.vue?vue&type=script&lang=js"
import style0 from "./LoadingMedicalIdentity.vue?vue&type=style&index=0&id=048d96f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d96f1",
  null
  
)

export default component.exports